
<script setup>
import Markdown from 'vue3-markdown-it'
import Image from '@/components/Image.vue'

const props = defineProps({
  content: Object
})
const coverObj = props.content.image.data.attributes
</script>

<template>
  <figure class="mb-8">
    <Image
      :content="coverObj"
      :class-list="'mx-auto'"
    />
    <figcaption class="text-lg text-center italic my-2 text-gray-500">
      <Markdown :source="content.caption" :linkify="true" :html="true" v-if="!!content.caption" />
    </figcaption>
  </figure>
</template>